import script from "./AddClient.vue?vue&type=script&setup=true&lang=js"
export * from "./AddClient.vue?vue&type=script&setup=true&lang=js"

import "./AddClient.vue?vue&type=style&index=0&id=0d4a6a6b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4a6a6b"]])

export default __exports__